/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from '../../../components/select';
import Input from '../../../components/input';

const ConfiguracionAvanzadaAcumulado = ({
  data, onChange, error, onBlur, tipoSensores
}) => {
  const [tipoSensorSelected, setTipoSensorSelected] = useState([]);

  useEffect(() => {
    if (tipoSensores && Array.isArray(tipoSensores)) {
      const excludeTipo = tipoSensores.filter((tipo) => tipo._id !== data.principal);
      // Agregar opción "No agregar sensor secundario" al inicio
      const opcionesSecundario = [
        { _id: '', nombre: 'No agregar sensor secundario' },
        ...excludeTipo
      ];
      setTipoSensorSelected(opcionesSecundario);
    } else {
      // Si no hay tipos de sensores, solo mostrar la opción de "no agregar"
      setTipoSensorSelected([{ _id: '', nombre: 'No agregar sensor secundario' }]);
    }
  }, [data.principal, tipoSensores]);

  // Preparar opciones para el select principal
  const opcionesPrincipal = tipoSensores && Array.isArray(tipoSensores) && tipoSensores.length > 0
    ? tipoSensores.map(tipo => ({ _id: tipo._id, nombre: tipo.nombre }))
    : [];

  return (
    <div className="form-info-container__box-grid">
      <div className="input-container">
        <Select
          label="Seleccionar Sensor Principal"
          value={data.principal}
          onChange={onChange}
          onBlur={onBlur}
          options={opcionesPrincipal}
          name="principal"
          error={error.principal}
        />
      </div>
      <div className="input-container">
        <Select
          label="Seleccionar Sensor Secundario"
          value={data.secundario}
          onChange={onChange}
          onBlur={onBlur}
          options={tipoSensorSelected}
          name="secundario"
          error={error.secundario}
        />
      </div>
      <div className="input-container">
        <Input
          name="conversion"
          label="Tasa de Conversión"
          placeholder="Ingrese la tasa de conversión"
          value={data.conversion}
          inputType="number"
          onChange={onChange}
          onBlur={onBlur}
          disabled={data.secundario === ''}
          error={error.conversion}
        />
      </div>
    </div>
  );
};

ConfiguracionAvanzadaAcumulado.propTypes = {
  tipoSensores: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  data: PropTypes.shape().isRequired,
  error: PropTypes.shape().isRequired
};

ConfiguracionAvanzadaAcumulado.defaultProps = {
  tipoSensores: [],
  onChange: () => { },
  onBlur: () => { },
};

export default ConfiguracionAvanzadaAcumulado;